import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {confirmPasswordValidator} from '../../../auth/reset-password/reset-password.component';
import {UserService} from '../../../auth/services/user.service';
import {ValidationMessageService} from '../../../shared/services/validation-message-handle';
import {ToastrService} from 'ngx-toastr';
import {QuestionModel} from '../../models/question.model';
import {QuestionnaireModel} from '../../models/questionnaire.model';
import {QuestionService} from '../../services/question.service';
import {finalize} from 'rxjs/operators';
import {ApiResponseModel} from '../../../shared/entities/api-response.model';
import {HttpErrorResponse} from '@angular/common/http';
import {AnswerModel, AnswersTypeModel} from '../../models/answer.model';
import {ActivatedRoute, Router} from '@angular/router';
import {UserModel} from '../../../auth/models/user.model';
import {MatCheckboxChange} from '@angular/material';

@Component({
  selector: 'admin-questionnaire-create',
  templateUrl: './questionnaire-create.component.html',
  styleUrls: ['./questionnaire-create.component.scss']
})

export class QuestionnaireCreateComponent implements OnInit {

    public loading = false;
    public questionnaireForm: FormGroup;
    public questionsList: Array<QuestionModel> = [];
    public listOfUsers: Array<UserModel> = [];
    public selectedUser: UserModel = null;
    public createNewEntity = true;
    public uid: string;

    constructor(
        private route: ActivatedRoute,
        private _formBuilder: FormBuilder,
        private validationMessageService: ValidationMessageService,
        private questionnarieService: QuestionService,
        private userService: UserService,
        private toastr: ToastrService,
        private router: Router
    ) {
        this.createForm();
        this.uid = this.route.snapshot.queryParams['uid'];
    }

    public createForm(): void
    {

      this.questionnaireForm = this._formBuilder.group({
          name : ['', Validators.required],
          forUser : [''],
          implicit: [''],
      });

    }

    ngOnInit(): void {

        this.getUserList();

        if (this.uid ){
            this.createNewEntity = false;
            this.getQuestionnarie(this.uid);

        }else{
            this.createNewEntity = true;
        }

    }

    addNewQuestion(): void {

        // Create a temporary unique code until save the question
        const uid = new Date().getUTCMilliseconds();

        const question: QuestionModel = new QuestionModel();

        question.uid = uid.toString();
        question.position = this.questionsList.length + 1;

        this.questionsList.push(question);

    }

    onDeleteQuestion(question: QuestionModel): void {
        console.log(question);
        this.questionsList = this.questionsList.filter(function( obj ) {
            return obj.uid !== question.uid;
        });
    }

    onUpdateQuestion(question: QuestionModel): void {
        const foundIndex = this.questionsList.findIndex(x => x.uid.toString() === question.uid.toString());
        this.questionsList[foundIndex] = question;
    }

    onSaveQuestionnaire(): void
    {

        const questionnaire = new QuestionnaireModel();

        questionnaire.name = this.questionnaireForm.get('name').value;
        questionnaire.forUser = this.questionnaireForm.get('forUser').value;
        questionnaire.questions = this.questionsList;
        questionnaire.uid = this.uid;
        questionnaire.implicit = this.questionnaireForm.get('implicit').value;

        this.loading = true;

        if (this.createNewEntity) {
            // Create new
            this.questionnarieService.saveQuestionnaire(questionnaire)
                .pipe(finalize(() => this.loading = false))
                .subscribe((response: ApiResponseModel) => {
                    this.toastr.success('Succes!', 'Chestionarul a fost salvate cu succes!');
                    this.router.navigate(['questionnaires/list']);
                }, err => {
                    if (err instanceof HttpErrorResponse) {
                        this.validationMessageService.serverSideValidation(err, this.questionnaireForm, '');
                    }
                });
        }else{
            // Update
            this.questionnarieService.updateQuestionnaire(questionnaire)
                .pipe(finalize(() => this.loading = false))
                .subscribe((response: ApiResponseModel) => {
                    this.toastr.success('Succes!', 'Chestionarul a fost modificat cu succes!');
                    this.router.navigate(['questionnaires/list']);
                }, err => {
                    if (err instanceof HttpErrorResponse) {
                        this.validationMessageService.serverSideValidation(err, this.questionnaireForm, '');
                    }
                });
        }



    }


    getQuestionnarie(uid: string): void
    {
        this.loading = true;
        this.questionnarieService.getQuestionnaire(uid)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: ApiResponseModel) => {

                this.questionnaireForm.patchValue({
                     name: response.payload.name,
                     forUser: response.payload.user,
                     implicit: response.payload.implicit,
                });

                if (response.payload.implicit){
                    this.changeForUserFieldState(false);
                }else{
                    this.selectedUser = response.payload.user;
                }



                const questions: Array<any> = response.payload.questions;

                this.questionsList = [];

                const _this = this;

                this.uid = response.payload.uid;

                questions.forEach(function(value, index){

                    const answareType = JSON.parse(value.answareType);
                    const questionValues = JSON.parse(value.values);

                    const questionModel = new QuestionModel().map({
                        id: value.id,
                        uid: value.uid,
                        position: value.position,
                        questionName: value.questionName,
                        answerType: new AnswersTypeModel().map(answareType),
                        answer: new AnswerModel(),
                    });


                    questionModel.answer.text = value.questionName;
                    questionModel.answer.type = answareType;
                    questionModel.answer.values = questionValues;

                    _this.questionsList.push(questionModel);

                });

                this.createNewEntity = false;

            }, err => {
                if (err instanceof HttpErrorResponse) {
                    this.validationMessageService.serverSideValidation(err, this.questionnaireForm, '');
                }
            });

    }

    getUserList(): void
    {
        this.loading = true;
        this.userService.getList()
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: ApiResponseModel) => {
                this.listOfUsers = response.payload;
            }, err => {
                if (err instanceof HttpErrorResponse) {
                    this.validationMessageService.serverSideValidation(err, this.questionnaireForm, '');
                }
            });

    }

    compareObjects(o1: any, o2: any): boolean {
        if (o1 && o2){
            return o1.uid === o2.uid;
        }else{
            return false;
        }
    }

    changeForUserFieldState(state: boolean): void
    {
        if (state === false) {

            this.selectedUser = null;
            this.questionnaireForm.patchValue({
                forUser: null,
            });
            this.questionnaireForm.controls['forUser'].disable();
        }else{
            this.questionnaireForm.controls['forUser'].enable();
        }
    }

    onImplicitChange($event: MatCheckboxChange): void {
        if ($event.checked) {
            this.changeForUserFieldState(false);
        }else{
            this.changeForUserFieldState(true);
        }
    }
}


